import { createContextValues } from '@connectrpc/connect';
import { BookingService } from '@qdrant/qdrant-cloud-public-api/booking/v1';
import {
  listGlobalPackages,
  listPackages,
  getQuote,
  getGlobalQuotes,
  listInferenceModels,
  getPackage,
  getBackupQuote,
} from '@qdrant/qdrant-cloud-public-api/booking/v1/connect-query';
import { transport } from '@/api/transport';
import { queryOptions, createServiceQueries } from '@/connect-query';
import { ctxKeyAuthorized } from '@/connect-query/context-keys';

export const BOOKING_PACKAGE_TYPE_FREE = 'free';
export const BOOKING_PACKAGE_TYPE_PAID = 'paid';
export const PRICING_TYPE_PREMIUM = 'premium_2025';
export const PRICING_TYPE_STANDARD = 'standard';

const contextValues = createContextValues().set(ctxKeyAuthorized, false);

export const BookingServices = createServiceQueries(BookingService, {
  getBackupQuoteQuery: (params) =>
    queryOptions(getBackupQuote, params, {
      transport,
    }),
  getGlobalQuotesQuery: (params) => queryOptions(getGlobalQuotes, params, { transport, contextValues }),
  getPackageQuery: (params) => queryOptions(getPackage, params, { transport }),
  getQuoteQuery: (params) => queryOptions(getQuote, params, { transport }),
  listGlobalPackagesQuery: (params) => queryOptions(listGlobalPackages, params, { transport, contextValues }),
  listInferenceModelsQuery: (params) =>
    queryOptions(listInferenceModels, params, { transport, select: (data) => data.items }),
  listPackagesQuery: (params) => queryOptions(listPackages, params, { transport, select: (d) => d.items }),
});
